import React from "react";
import PropTypes from "prop-types";
import { Markdown } from "@storybook/blocks";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

// Displays modal with buttons for user actions
function ButtonModal(props) {
  return (
    <Modal
      onHide={props.onClose || props.onHide}
      data-testid="modal"
      show={props.show}
      centered={props.centered}
      className={props.modalClass}
      keyboard={props.keyboard ?? true}
      backdrop={props.backdrop ?? true}
    >
      <Modal.Header closeButton={props.showCloseButton ?? true} className={props.headerClass}>
        <Modal.Title className={props.titleClass}>{props.heading}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.children ? (
          props.children
        ) : (
          <Markdown className={props?.contentClass}>{props.message}</Markdown>
        )}
      </Modal.Body>
      {(
        <Modal.Footer className={props.footerClass || ''}>
          {props.btn_label_1 && (<Button onClick={props.onHide} variant="outline-primary" color="danger" className={props.btn1_class}>
            {props.btn_label_1}
          </Button>
          )}
          <Button onClick={props.onClick} variant="primary" className={props.btn2_class}>
            {props.btn_label_2}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}
ButtonModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  heading: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  btn_label_1: PropTypes.string.isRequired,
  btn_label_2: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  headerClass: PropTypes.string,
  footerClass: PropTypes.string,
  modalClass: PropTypes.string,
  titleClass: PropTypes.string,
  btn1_class: PropTypes.string,
  btn2_class: PropTypes.string,
  centered: PropTypes.bool
};

export default ButtonModal;


